import * as yup from "yup";

let loginFormValidationSchema = yup.object().shape({
  email: yup.string().trim().lowercase().required("This field is required"),
  password: yup.string().trim().required("Password is required"),
});

let forgetPasswordValidationForm = yup.object().shape({
  email: yup.string().email().required("Email is required"),
});
let confirmPasswordResetValidationForm = yup.object().shape({
  otp: yup
    .string()
    .required("OTP is required")
    .matches(/^\d+$/, "OTP must be a numeric value"),
  password: yup
    .string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters long")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/[0-9]/, "Password must contain at least one number")
    .matches(
      /[!@#$%^&*(),.?":{}|<>]/,
      "Password must contain at least one special character"
    ),
  confirm_password: yup
    .string()
    .required("Please confirm your password")
    .oneOf([yup.ref("password"), null], "Passwords must match"),
});

let changePasswordValidationForm = yup.object().shape({
  password: yup.string().required("Password is required"),
  confirm_password: yup
    .string()
    .oneOf([yup.ref("password"), ""], "Passwords don't match!")
    .required("Required"),
});

let createFirstUserValidationFrom = yup.object().shape({
  email: yup.string().email().required("Email is required"),
  username: yup.string().required("Username is required"),
  full_name: yup.string().required("Full Name is required"),
  mobile_number: yup.string().required("Phone Number is required"),
  password: yup.string().required("Password is required"),
  confirm_password: yup
    .string()
    .oneOf([yup.ref("password"), ""], "Passwords don't match!")
    .required("Required"),
});

export {
  loginFormValidationSchema,
  forgetPasswordValidationForm,
  confirmPasswordResetValidationForm,
  changePasswordValidationForm,
  createFirstUserValidationFrom,
};
